<template>
  <div class="last-update mt-4">
    <small>
      <i class="fas fa-calendar-alt mr-2"></i>
      Ultimo aggiornamento: {{ updateDate }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'LastUpdate',
  props: {
    updateDate: {
      type: String,
      default: 'Luglio 2026'
    }
  }
}
</script>

<style scoped>
.last-update {
  color: rgba(255, 255, 255, 0.8);
  animation: fadeInUp 0.8s ease-out 1s both;
}

.last-update i {
  margin-right: 0.5rem;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

